<template>
  <app-warp title='经销商业务员' color='#efefef' padding='true'>
    <template #app-content>
      <div class="navListBox width100">
        <div class="headBgImg s_po_re" v-show='activeKey == 1'
          style='background:linear-gradient(90deg, #E2F4FF 0%, #DFE7FF 100%);'>
          <div class="s_flex_bian_c p-tb0-lr15 width100 p-t-15">
            <div class="s_flex_ali">
              <img class="width-60 height-60" src="@/assets/images/user.png" alt="">
              <div class="m-l-10">
                <p class="fz-16 s_font_b s_c333">业务员-张三</p>
                <p class="s_c9d m-t-5 fz-13 ">级别：省代</p>
              </div>
            </div>
            <div class="s_flex_center s_cfff width-100 height-35"
              style="background: linear-gradient(270deg, #5DB1FF 0%, #6A78FF 100%);border-radius: 20px;">
              <ScanOutlined />
              扫码核销
            </div>
          </div>
        </div>
        <div class="s_po_re s_bf p-l-10 p-r-10"
          style="top:-20px;left:50%;transform: translateX(-50%);border-top-left-radius: 10px;border-top-right-radius: 10px;"
          v-show='activeKey == 1'>
          <div class="s_flex_wrap s_flex_bian_c p-b-10 p-t-20" style="border-bottom:1px solid #EEEEEE;" v-show="is_show_order">
            <div class=" s_flex_center s_flex_fdc flex_1">
              <cIcon type="dfh" size="28" />
              <p class="s_c333 text-ac fz-13 m-t-5">待发货</p>
            </div>
            <div class="s_flex_center s_flex_fdc flex_1">
              <cIcon type="dhx" size="28" />
              <p class="s_c333 text-ac fz-13 m-t-5">待核销</p>
            </div>
            <div class="s_flex_center s_flex_fdc flex_1">
              <cIcon type="dtk" size="28" />
              <p class="s_c333 text-ac fz-13 m-t-5">待退款</p>
            </div>
            <div class="s_flex_center s_flex_fdc flex_1">
              <cIcon type="qbdd" size="28" />
              <p class="s_c333 text-ac fz-13 m-t-5">全部订单</p>
            </div>
          </div>
          <div v-for='item in homeList' :key='item.id'>
            <div style="border-bottom:1px solid #EEEEEE;" v-show="item.children.filter(v=>v.checked).length>0">
              <p class="m-b-15 fz-15 p-t-15 s_c333 s_font_b">{{item.menu_name}}</p>
              <div class="s_flex_wrap  s_flex_ali">
                <template v-for='items in item.children' :key='items.id'>
                  <div class="m-b-20 width25 s_flex_center s_flex_fdc" v-show="items.checked">
                    <cIcon :type="items.icon" size="28" />
                    <p class="s_c333 text-ac fz-12 m-t-5">{{items.menu_name}}</p>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div class="p-t-35 p-b-35" v-show="allHide">
            <a-empty
              :image="require('@/assets/images/original.png')"
              :image-style="{
                height: '80px',
              }"
            >
            <template #description>
              <span class="s_c999">暂未勾选任何菜单</span>
            </template>
            </a-empty>
          </div>
        </div>
        <div class="s_po_re p-t-10" v-show='activeKey == 2'  >
          <div v-for='item in reportFormList' :key='item.id'>
            <div class="s_bf m-b-10" v-show="item.children.filter(v=>v.checked).length>0">
              <p class="m-b-15 fz-15 p-t-15 m-l-15 s_c333">{{item.menu_name}}</p>
              <div class="s_flex_wrap  s_flex_ali">
                <template v-for='items in item.children' :key='items.id'>
                  <div class="m-b-20 width25 s_flex_center s_flex_fdc" v-show="items.checked">
                    <cIcon :type="items.icon" size="28" />
                    <p class="s_c333 text-ac fz-12 m-t-5">{{items.menu_name}}</p>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div class="p-t-35 p-b-35 s_bf" v-show="allHide">
            <a-empty
              :image="require('@/assets/images/original.png')"
              :image-style="{
                height: '80px',
              }"
            >
            <template #description>
              <span class="s_c999">暂未勾选任何菜单</span>
            </template>
            </a-empty>
          </div>
        </div>
      </div>
      <div class="height-50 s_bf width100 s_flex_bian_c s_bor_t_cd9 s_po_ab_bl">
        <p class="height-45 s_flex_center width33 s_flex_fdc">
          <cIcon :type="activeKey==1?'sy_1':'sy'" size="20" @click="activeKey = 1;checkAllHide()" />首页
        </p>
        <p class="height-45 s_flex_center width33 s_flex_fdc">
          <cIcon :type="activeKey==1?'sj':'sj_1'" size="20" @click="activeKey = 2;checkAllHide()" />数据
        </p>
        <p class="height-45 s_flex_center width33 s_flex_fdc">
          <cIcon type="wd" size="20" />我的
        </p>
      </div>
    </template>
    <template #app-sider>
      <div class="p-24">
        <p class="s_c999"><span class="p-r-15 fz-18 s_font_b s_c333">首页菜单</span>设置是否在经销商后台首页显示，去掉勾选则不显示</p>
        <a-divider />
        <div class="m-b-20" v-show="is_show_order_form">
          订单管理：
          <a-radio-group v-model:value="is_show_order">
            <a-radio :value="1">显示</a-radio>
            <a-radio :value="0">隐藏</a-radio>
          </a-radio-group>
        </div>
        <a-tabs type="card" v-model:activeKey="activeKey" @change="checkAllHide">
          <a-tab-pane :key="1" tab="首页">
            <div class="s_flex_ali" style="border-bottom: 1px solid #f0f0f0;line-height: 46px;">
              <p class="height-46 flex_1 text-ac s_po_re s_shou" :class="navHomeIndex==index?'navIndex':''"
                v-for="(v,index) in homeList" :key="v.id" @click="navHomeIndex=index">{{v.menu_name}}</p>
            </div>
            <div class="s_flex_wrap s_flex_ali m-t-20 ">
              <div class="m-b-20 width20 s_flex_center s_flex_fdc" v-for='items in homeList[navHomeIndex].children'
                :key='items.id'>
                <cIcon :type="items.icon" size="28" class="m-b-5" />
                <a-checkbox v-model:checked="items.checked" @change="checkAllHide"><span class="s_c333">{{items.menu_name}}</span></a-checkbox>
              </div>
            </div>
          </a-tab-pane>
          <a-tab-pane :key="2" tab="数据">
            <div class="s_flex_ali" style="border-bottom: 1px solid #f0f0f0;line-height: 46px;">
              <p class="height-46 flex_1 text-ac s_po_re s_shou" :class="navDataIndex==index?'navIndex':''" v-for="(v,index) in reportFormList" :key="v.id" @click="navDataIndex=index">{{v.menu_name}}</p>
            </div>
            <div class="s_flex_wrap s_flex_ali m-t-20 ">
              <div class="m-b-20 width20 s_flex_center s_flex_fdc" v-for='items in reportFormList[navDataIndex].children' :key='items.id'>
                <cIcon :type="items.icon" size="28" class="m-b-5" />
                <a-checkbox v-model:checked="items.checked" @change="checkAllHide"><span class="s_c333">{{items.menu_name}}</span></a-checkbox>
              </div>
            </div>
          </a-tab-pane>
        </a-tabs>
      </div>

      <a-button class="width-100 m-l-24 m-b-24" type="primary" v-has:setDealerSaleTemplate="setData">保存</a-button>
    </template>
  </app-warp>
</template>
<script>
  import { ScanOutlined } from "@ant-design/icons-vue";
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { iscode } from "@/utils/app";
  import store from '@/store'
  import { getDealerSaleTemplateMenu, setDealerSaleTemplateMenu } from '@/api/dealer';
  import cIcon from "./c-icon";
  export default {
    components: { cIcon, ScanOutlined },
    setup(props) {
      const state = reactive({ 
        is_show_order:1, 
        is_show_order_form:1,
        navHomeIndex:0,
        navDataIndex:0,
        activeKey: 1,
        allHide:true,
        homeList: [
          {
            name: "云店管理",
            children: [
              { 
                name: "云店订单",
                icon: "yddd",
                checked: false,
                url: "/pages/order/order_list?current=0",
              },
              {
                name: "财务中心",
                icon: "cwzx",
                checked: false,
                url: "/pages/finance_center/index",
              },
              {
                name: "直播海报",
                icon: "zbhb",
                checked: false,
                url: "/pages/live/index",
              },
              {
                name: "秒杀海报",
                icon: "mshb",
                checked: false,
                url: "/pages/seckill/index",
              },
              {
                name: "拼团海报",
                icon: "pthb",
                checked: false,
                url: "/pages/group/index",
              },
            ]
          },
          {
            name: "智能防窜",
            children: [
              {
                name: "出货扫描",
                icon: "chsm",
                checked: false,
                url: "/pages/anti_fleeing_goods/scanCodeForGoods",
              },
              {
                name: "退货扫描",
                icon: "thsm",
                checked: false,
                url: "/pages/anti_fleeing_goods/returnsManagement",
              },
              {
                name: "出货记录",
                icon: "chjl",
                checked: false,
                url: "/pages/anti_fleeing_goods/shipmentRecord",
              },
              {
                name: "商品签收",
                icon: "spqs",
                checked: false,
                url: "/pages/anti_fleeing_goods/commodityReceipt"
              },
              {
                name: "商品追踪",
                icon: "spzz",
                checked: false,
                url: "",
                type: 'scanCode'
              },
            ]
          },
          {
            name: "资产管理",
            children: [
              {
                name: "我的积分",
                icon: "wdjf",
                checked: false,
                url: "/pages/my_points/index",
              },
              {
                name: "我的优惠券",
                icon: "wdyhq",
                checked: false,
                url: "/pages/my_coupon/index",
              },
              {
                name: "我的礼品",
                icon: "wdlp",
                checked: false,
                url: "/pages/my_prize/index",
              },
            ]
          },
          {
            name: "角色管理",
            children: [
              {
                name: "经销商管理",
                icon: "jxsgl",
                checked: false,
                url: "/pages/dealer/dealer",
              },
              {
                name: "门店管理",
                icon: "mdgl",
                checked: false,
                url: "/pages/store/store",
              },
            ]
          },
          {
            name: "报销",
            children: [
              {
                name: "申请报销",
                icon: "sqbx",
                checked: false,
                url: "/pages/expense_account/applyExpenseAccount?type=self",
              },
              {
                name: "下级报销",
                icon: "xjbx",
                checked: false,
                url: "/pages/expense_account/superiorExpenseAccount?type=sub",
              },
              {
                name: "上级报销",
                icon: "sjbx",
                checked: false,
                url: "/pages/expense_account/superiorExpenseAccount?type=sup",
              },
              {
                name: "给下级报销",
                icon: "gxjbx",
                checked: false,
                url: "/pages/expense_account/giveExpenseAccount",
              },
            ]
          },
          {
            name: "订货管理",
            children: [
              {
                name: "发货管理",
                icon: "fhgl",
                checked: false,
                url: "/pages/order_goods/deliveryManagement",
              },
              {
                name: "售后管理",
                icon: "shgl",
                checked: false,
                url: "/pages/order_goods/afterSale",
              },
              {
                name: "下级订货管理",
                icon: "xjdhgl",
                checked: false,
                url: "/pages/order_goods/orderManagement",
              },
              {
                name: "当面交易核销",
                icon: "dmjyhx",
                checked: false,
                url: "",
                type: "writeOff"
              }
            ]
          },
          {
            name: "其他功能",
            children: [
              {
                name: "退货地址",
                icon: "thdz",
                checked: false,
                url: "/pages/order_goods/returnAddress",
              },
              {
                name: "物流公司",
                icon: "wlgs",
                checked: false,
                url: "/pages/freight/company_list",
              },
              {
                name: "运费模板",
                icon: "yfmb",
                checked: false,
                url: "/pages/freight/index?type=2",
              }
            ]
          },
        ],

        reportFormList: [
          {
            name: '智能防窜',
            children: [
              {
                icon: "kcsl",
                name: "仓库数量",
                url: "/pages/anti_fleeing_goods/storeManagement",
                checked: false,
              },
              {
                icon: "xjkc",
                name: "管辖门店库存",
                url: "/pages/chart/storeData",
                checked: false,
              },
            ]
          },
          {
            name: '营销数据',
            children: [
              {
                icon: "smsj",
                name: "扫码数据",
                url: "/pages/chart/scanCodeData",
                checked: false,
              },
              {
                icon: "hxjl",
                name: "核销记录",
                url: "/pages/writeOffRecord/index",
                checked: false,
              }
            ]
          },

          {
            name: '云店商城数据',
            children: [{
              icon: "wdkh",
              name: "我的客户",
              url: "/pages/customer/customer",
              checked: false,
            },
            {
              icon: "xjdd",
              name: "下级订单",
              url: "/pages/order/order_subordinate",
              checked: false,
            },
            ]
          },

          {
            name: '总部代发数据',
            children: [
              {
                icon: "xssj",
                name: "销售数据",
                url: "/pages/chart/saleData",
                checked: false
              },
              {
                icon: "qdxssj",
                name: "渠道销售数据",
                url: "/pages/chart/channelData",
                checked: false
              }
            ]
          },
          {
            name: '超级导购',
            children: [
              {
                icon: "hxmx",
                name: "核销明细",
                url: "/pages/chart/guide/writeOff",
                checked: false
              }
            ]
          },
        ],
      }); 
      const checkAllHide = () =>{
        state.allHide = true
        if(state.activeKey == 1){
          state.homeList.forEach(v=>{
            v.children.forEach(k=>{
              if(k.checked){
                state.allHide = false
              }
            })
          })
        }else{
          state.reportFormList.forEach(v=>{
            v.children.forEach(k=>{
              if(k.checked){
                state.allHide = false
              }
            })
          })
        }
      }
      const initData = async () => {
        let result = await getDealerSaleTemplateMenu().then(res => res.data).catch(error => error);
        if (iscode(result)) {
          state.homeList = result.data.home_menu_list;
          state.reportFormList = result.data.data_menu_list; 
          state.is_show_order_form = result.data.order_menu.is_show; 
          state.is_show_order = result.data.order_menu.checked;
          checkAllHide();
        } else {
          message.error(result.msg);
        }
      }
      const setData = async () => {
        const hide = message.loading('正在加载中...', 0);
        var home_ids = [];
        var data_ids = [];
        state.homeList.forEach(v=>{
          if(v.children.filter(s=>s.checked).length){
            home_ids.push(v.id)
          }
          v.children.forEach(k=>{
            if(k.checked){
              home_ids.push(k.id)
            }
          })
        })
        state.reportFormList.forEach(v=>{
          if(v.children.filter(s=>s.checked).length){
            data_ids.push(v.id)
          }
          v.children.forEach(k=>{
            if(k.checked){
              data_ids.push(k.id)
            }
          })
        })
        let result = await setDealerSaleTemplateMenu({order_menu_is_show:state.is_show_order,menu_ids:home_ids.concat(data_ids)}).then(res => res.data).catch(error => error)
        setTimeout(hide);
        if (iscode(result)) {
          initData();
          message.success(result.msg);
        } else {
          message.error(result.msg);
        }
      }
      onMounted(() => {
        initData();
      });
      return {
        ...toRefs(state),
        setData,
        initData,
        checkAllHide
      };
    },
  };
</script>
<style lang="less" scoped>
  .navIndex {
    color: #05486A;
    font-weight: bold;
  }

  .navIndex::after {
    content: '';
    width: 50%;
    height: 2px;
    background-color: #05486A;
    position: absolute;
    bottom: 0px;
    left: 50%;
    margin-left: -25%;
  }

  .headBgImg {
    height: 120px;
    background-size: cover;
  }

  .positionBox {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }

  .positionBox:hover {
    border: 2px dashed rgba(255, 0, 0, 0.5);
    box-sizing: border-box;
  }

  .borderRed2 {
    border: 2px dashed rgba(255, 0, 0, 0.5);
  }

  .navListBox {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 45px;
    overflow-y: scroll;
  }
</style>